__turbopack_context__.v({
  "campaignIcon": "NewWhereToGoMobileView-module__Z5Fr5G__campaignIcon",
  "campaignLabel": "NewWhereToGoMobileView-module__Z5Fr5G__campaignLabel",
  "footer": "NewWhereToGoMobileView-module__Z5Fr5G__footer",
  "searchInputWrapper": "NewWhereToGoMobileView-module__Z5Fr5G__searchInputWrapper",
  "spring-rotation": "NewWhereToGoMobileView-module__Z5Fr5G__spring-rotation",
});
